var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssistantListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9344 22H1.95438C0.327467 22 0 21.1103 0 20.0177V6.14665C0 5.28543 0.327467 4.16535 1.95438 4.16535H3.90876V2.18303H4.71546C5.17702 0.480272 6.78102 0 8.79464 0C10.6212 0 12.2252 0.480272 12.6868 2.18303H13.8677V4.16535H15.9344C17.6829 4.16535 18 5.28543 18 6.14665V20.0177C18 21.1103 17.6829 22 15.9344 22ZM8.79464 1.19289C7.93805 1.19289 7.27068 1.59149 6.91203 2.18303H10.4902C10.1316 1.59149 9.46412 1.19289 8.79464 1.19289ZM11.8011 4.16535H5.86314V6.14665H11.8011V4.16535ZM15.9344 6.14665H13.8677V8.12795H3.90876V6.14665H1.95438V20.0177H15.9344V6.14665ZM12.8344 11.5964H4.88595V9.61418H12.8344V11.5964ZM12.8344 15.064H4.88595V13.0827H12.8344V15.064ZM12.8344 18.4478H4.88595V16.4665H12.8344V18.4478Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantListIcon);
export default __webpack_public_path__ + "static/media/assistant-list-icon.e45279ffe73a9287c3ce05af2aa2a07b.svg";
export { ForwardRef as ReactComponent };